import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap5/Form';

import {
  ErrorMessage,
  Field,
  useField,
} from 'formik';

export default function HorizontalTextField(props) {
  const {
    name, label, placeholder, type, hint, required, wrapperClassName, ...rest
  } = props;

  const meta = useField(props)[1];

  return (
    <Form.Group className={wrapperClassName} controlId="formBasicEmail">
      {label && (
        <Form.Label>
          <>
            {label}
            {required && <abbr className="ms-1" title="required">*</abbr>}
          </>
        </Form.Label>
      )}
      <Field
        autoComplete="off"
        className={`form-control ${meta.error !== undefined && meta.touched ? 'is-invalid' : ''}`}
        type={type}
        name={name}
        placeholder={placeholder}
        {...rest}
      />
      {hint && <Form.Text className="text-muted">{hint}</Form.Text>}
      <ErrorMessage
        name={name}
        render={(msg) => <Form.Control.Feedback type="invalid">{msg}</Form.Control.Feedback>}
      />
    </Form.Group>
  );
}

HorizontalTextField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  hint: PropTypes.string,
  required: PropTypes.bool,
  wrapperClassName: PropTypes.string,
};

HorizontalTextField.defaultProps = {
  placeholder: '',
  type: 'text',
  hint: '',
  required: false,
  wrapperClassName: 'mb-3',
};
